export default __webpack_public_path__ + "static/media/bracers_of_the_farseeker.9ec5e931.jpg";